import { render, staticRenderFns } from "./EmployeesUpload.vue?vue&type=template&id=5b8b8f4c&scoped=true"
import script from "./EmployeesUpload.vue?vue&type=script&lang=js"
export * from "./EmployeesUpload.vue?vue&type=script&lang=js"
import style0 from "./EmployeesUpload.vue?vue&type=style&index=0&id=5b8b8f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b8f4c",
  null
  
)

export default component.exports